import React, {useState} from 'react'
import { DrillDownEvent } from '../types'

type IMarker = {
    event: DrillDownEvent, 
    path?: string
    strokeColor?: string
    url?: string
    zIndex?: number
}

export const useMarkers = (map: google.maps.Map) => {

    const [markers, setMarkers] = useState({})

    const clearMarkers = () => {
        if (markers !== null) {
            Object.keys(markers).forEach(key => {
                markers[key].setMap(null)
            })
        }

        setMarkers({})
    }

    const createMarkers = (imarkers: IMarker[]) => {
        return new Promise(res => {
            clearMarkers()
            let markersAux = {}
            imarkers.forEach(ele => markersAux = {...markersAux, ...createMarker(ele)})
            setMarkers(markersAux)

            res(markersAux)
        })
    }

    const createMarker = (imarker: IMarker): {[key: string]:google.maps.Marker} => {

        const {event, path, strokeColor, url} = imarker
        if (event && map) {            
            const {lat, lng} = event
            const key = lat+","+lng

            try{
                const marker: google.maps.Marker = new google.maps.Marker({
                    map,
                    position: { lat, lng },
                    icon: {url}
                });

                const aux = {}
                aux[key] = marker
                return aux
            }
            catch(error){
                console.log("ERROR TO CREATE MARKER", error)
                return null
            }
        }
    }

    return {createMarkers}
}